<template>
    <div>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-12">
                        <h3 class="mb-0">ยืนยันตัวตน</h3>
                    </div>
                </div>
            </div>
            <div class="row p-3 mt-1 text-center">
                <div :class="[(commission.statusVerify == '-3' || commission.statusVerify == 'null') ? 'col-4':'col-6' ,'pb-2 text-right']">
                    <h3 class="mb-0">สถานะ:</h3>
                </div>
                <div :class="[(commission.statusVerify == '-3' || commission.statusVerify == 'null') ? 'col-8':'col-6' , 'pb-2 text-left']">
                    <b-badge :variant="statusCommission( commission.statusVerify ).color +' report'" >
                        {{ statusCommission( commission.statusVerify ).status }}
                    </b-badge>
                </div>
                <template v-if="commission.statusVerify == '-3'">
                    <div class="col-4 pb-4 text-right">
                    <h3 class="mb-0">เหตุผล:</h3>
                    </div>
                    <div class="col-8 pb-4 text-left">
                        <h4>{{commission.remarkVerify}}</h4>
                    </div>
                </template>
                <template v-if="this.$USER_LOGIN.get().isSuperAdmin">
                    <div class="col-6 pb-2">
                        <button 
                            class="btn btn-info btn-block btn-icon py-2 mb-2" 
                            @click="$router.push({ name:'resgisterCommission' })" 
                            v-if="(commission.statusVerify == '-3' || commission.statusVerify == 'null')"
                        >
                            {{ (commission.statusVerify == ' null' ? 'ยืนยันตัวตน' : 'อัพเดทข้อมูล') }}
                        </button>
                    </div>
                    <div class="col-12" v-if="commission.statusVerify == '-3'">
                        <h4 class="text-muted">หากคุณไม่ยืนยันตัวตน จะไม่ได้รับค่าคอมมิชชัน ของรายการพัสดุที่เก็บเงินปลายทาง</h4>
                    </div>
                    <div class="col-12" v-else-if="commission.statusVerify == '0'">
                        <h4 class="text-muted">กรุณารอพนักงานตรวจสอบข้อมูล 1-3 วันทำการ</h4>
                    </div>
                </template>
            </div>
        </card>
    </div>
</template>

<script>
import { statusCommission } from "@/plugins/statusCommission.js"

export default {
    data(){
        return{
            commission:{
                statusVerify: null,
                remarkVerify: null,
            },
            statusCommission: statusCommission,
        }
    },
}
</script>